import { ReactComponent as People } from '../../components/icons/people.svg';
import { ReactComponent as StatusUp } from '../../components/icons/status-up.svg';
import { ReactComponent as Trainings } from '../../components/icons/vid-oct.svg';
import {userActions} from "../users/userTableConfig";
import CustomButton from "../../components/components/custom_button/customButton";
import { getStatsOpen, toggleGetStats }    from "../../store/statsTabSlice";

export const empty = [];

// Konfiguracja zakładek
export const tabsConfig = (activeTab, dispatch, setActiveTab) => [
  {
    icon: StatusUp,
    name: 'Statystyki ogólne',
    hoverClass: 'hover-effect',
    activeClass: activeTab === 'Statystyki ogólne' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Statystyki ogólne', dispatch, setActiveTab),
    toggleActive: true,
  },
  {
    icon: People,
    name: 'Użytkownicy',
    hoverClass: 'hover-effect',
    activeClass: activeTab === 'Użytkownicy' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Użytkownicy', dispatch, setActiveTab),

    toggleActive: true,
  },
  {
    icon: Trainings,
    name: 'Treningi',
    hoverClass: 'hover-effect',
    activeClass: activeTab === 'Treningi' ? 'is-active' : '',
    onClick: () => userActions.changeTab('Treningi', dispatch, setActiveTab),

    toggleActive: true,
  },
];

// Konfiguracja prawej strony
export const rightSideConfig = (searchValue, dispatch) => [
    {
        icon: StatusUp,
        name: 'Pobierz dane',
        hoverClass: 'hover-effect',
        activeClass: '',
        onClick: () => {
            dispatch(toggleGetStats());
        },
        toggleActive: false,
    },
];